<template>
	<div class="supplements">
		<v-row no-gutters align="center" class="mb-5">
			<v-btn
				color="primary"
				fab
				x-small
				@click="searchSupplement = !searchSupplement"
				:disabled="!$store.getters.hasModule('fito')"
			>
				<v-icon>add</v-icon>
			</v-btn>
			<v-spacer></v-spacer>
			<v-btn
				color="primary"
				small
				@click="showRecommendations = true"
				:disabled="!$store.getters.hasModule('fito')"
			>
				<translate>Recommendations</translate>
			</v-btn>
			<CMMRecommendations
				v-if="showRecommendations"
				v-model="showRecommendations"
				@add-recommendations="addRecommendations"
				type="supplement"
			/>
		</v-row>
		<v-row v-if="searchSupplement" no-gutters class="my-6 px-3">
			<v-col cols="12">
				<SearchProducts context="appointment" @add-product="addSupplement" @new-product="newSupplement" type="supplement" :providersFilter="true" />
			</v-col>
		</v-row>
		<v-row no-gutters>
			<v-col cols="12">
				<ProductList
					:products="supplements.products"
					context="appointment"
					type="supplement"
					@remove-product="removeSupplement"
					@edit-posology="editPosology"
				/>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import ProductList from "@/components/products/ProductList.vue";
import SearchProducts from "@/components/products/SearchProducts.vue";
import CMMRecommendations from "@/components/appointment/treatments/tcm/CMMRecommendations.vue";
import axios from "axios";

export default {
	name: "Supplements",
	props: ["supplements"],
	components: {
		ProductList,
		SearchProducts,
		CMMRecommendations
	},
	data: () => ({
		searchSupplement: false,
		showRecommendations: false
	}),
	methods: {
		addRecommendations(supplements) {
			//supplements.forEach(s => this.addSupplement(s));
			const appointmentId = this.$route.params.aid;
			const patientId = this.$route.params.aid;
			axios
				.post(
					"/patient/" +
						patientId +
						"/appointment/" +
						appointmentId +
						"/add_products",
					{
						products: supplements.map(function(s) {
							return s.id;
						})
					}
				)
				.then(response => {
					if (response.status === 200) {
						console.log(response.data);
						response.data.supplements.forEach(p => {
							this.supplements.products.push(p);
						});
						//this.getSubstanceQuantity();
						//this.supplements.substance_quantity = response.data.substance_quantity;
					}
				})
				.catch(error => console.log(error));
		},
		removeSupplement(supplement) {
			//CALL API
			const appointmentId = this.$route.params.aid;
			const patientId = this.$route.params.aid;
			axios
				.post(
					"/patient/" +
						patientId +
						"/appointment/" +
						appointmentId +
						"/product/" +
						supplement.product.id +
						"/delete"
				)
				.then(response => {
					if (response.status === 200) {
						console.log(response.data);
						//this.supplements = response.data.supplements;
						this.supplements.products.splice(
							this.supplements.products.indexOf(supplement),
							1
						);
						//this.getSubstanceQuantity();
					}
				})
				.catch(error => console.log(error));
			// this.selectedSupplements.splice(
			//   this.selectedSupplements.indexOf(supplement),
			//   1
			// );
		},
		addSupplement(supplementId) {
			//CALL API
			var exist = false;
			for (var i = 0; i < this.supplements.products.length; i++) {
				if (this.supplements.products[i].product.id == supplementId) {
					exist = true;
					break;
				}
			}
			if (!exist) {
				//CALL API
				console.log("ADD SUPPLEMENT");
				const appointmentId = this.$route.params.aid;
				const patientId = this.$route.params.aid;
				axios
					.post(
						"/patient/" +
							patientId +
							"/appointment/" +
							appointmentId +
							"/product/" +
							supplementId +
							"/add"
					)
					.then(response => {
						if (response.status === 200) {
							console.log(response.data);
							this.supplements.products.push(response.data.product);
							//this.supplements.substance_quantity = response.data.substance_quantity;
							//this.getSubstanceQuantity();
						}
					})
					.catch(error => console.log(error));

				//this.products.push(supplement);
			}
		},
		newSupplement(supplementName) {
			console.log("ADD NEW SUPPLEMENT");
			const appointmentId = this.$route.params.aid;
			const patientId = this.$route.params.aid;
			const formData = new FormData();
			formData.append("name", supplementName);
			axios
				.post(
					"/patient/" +
						patientId +
						"/appointment/" +
						appointmentId +
						"/product/add_new",
					formData
				)
				.then(response => {
					console.log(response.data);
					if (response.status === 200) {
						this.supplements.products.push(response.data.product);
					}
				})
				.catch(error => console.log(error));
		},
		editPosology(supplement, frequency) {
			const appointmentId = this.$route.params.aid;
			const patientId = this.$route.params.aid;
			const formData = new FormData();
			formData.append("morning", frequency.morning);
			formData.append("middle_morning", frequency.middle_morning);
			formData.append("half_day", frequency.half_day);
			formData.append(
				"middle_afternoon",
				frequency.middle_afternoon
			);
			formData.append("night", frequency.night);
			if (frequency.aditional_info != null) {
				formData.append("aditional_info", frequency.aditional_info);
			}
			axios
				.post(
					"/patient/" +
						patientId +
						"/appointment/" +
						appointmentId +
						"/product/" +
						supplement.product.id +
						"/edit/" + frequency.id,
					formData
				)
				.then(response => {
					if (response.status === 200) {
						console.log(response.data);
						if (response.data.result === "edited") {
							//this.supplements.substance_quantity = response.data.substance_quantity;
						}
					}
				})
				.catch(error => console.log(error));
		},
		getSubstanceQuantity() {
			const appointmentId = this.$route.params.aid;
			const patientId = this.$route.params.aid;
			axios
				.get(
					"/patient/" +
						patientId +
						"/appointment/" +
						appointmentId +
						"/supplements_substance_quantity"
				)
				.then(response => {
					if (response.status === 200) {
						console.log(response.data);
						this.supplements.substance_quantity =
							response.data.substance_quantity;
					}
				})
				.catch(error => console.log(error));
		}
	},
	created() {
		this.$root.$on('tour-treatments-supplements', () => {
			this.searchSupplement = true;
		});
		this.$root.$on('tour-treatments-supplements-add', () => {
			this.addSupplement(242);
			this.searchSupplement = false;
		});
	}
};
</script>

<style scoped>
.v-input__slot {
	min-height: 40px !important;
}
</style>